module.exports = __webpack_public_path__ + "img/icon-white-45.1a11c542.svg";